import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import { Marker } from 'react-leaflet';
import ReactDOMServer from 'react-dom/server';

import { Text } from 'v3/components';
import { Col } from 'react-bootstrap';
import { PopupContainer } from './styles';

const getTollCoordinate = (toll, fieldNames = []) => {
  for (const fieldName of fieldNames) {
    const value = Number(toll?.[fieldName]);
    if (!Number.isNaN(value)) return value;
  }

  return null;
};

function MarkerTollsPlazaInfo({ toll, onClose }) {
  const markerRef = useRef(null);
  const lat = getTollCoordinate(toll, ['lat', 'latitude']);
  const lng = getTollCoordinate(toll, ['long', 'lng', 'lon', 'longitude']);

  useEffect(() => {
    const element = markerRef.current?.getElement?.();
    const closeButton = element?.querySelector?.('.toll-plaza-info-close');

    if (!closeButton) return undefined;

    const handleCloseClick = (event) => {
      L.DomEvent.stopPropagation(event);
      L.DomEvent.preventDefault(event);
      onClose?.();
    };

    closeButton.addEventListener('click', handleCloseClick);

    return () => {
      closeButton.removeEventListener('click', handleCloseClick);
    };
  }, [onClose, toll?.codeAntt]);

  if (lat === null || lng === null) return null;

  const customIcon = L.divIcon({
    className: '',
    html: ReactDOMServer.renderToString(
      <PopupContainer>
        <div className="toll-plaza-info-header">
          <Text fontSize={12} weight={600}>
            {toll?.name}
          </Text>

          <button
            type="button"
            className="toll-plaza-info-close"
            aria-label="Fechar informações do pedágio"
          >
            ×
          </button>
        </div>

        <Col>
          <Text fontSize={12} weight={600}>
            {toll?.address}
          </Text>
        </Col>

        <Col>
          <Text fontSize={12} weight={600} color="#a72828ff">
            R$: {toll?.tollValue?.toFixed(2)}
          </Text>
        </Col>
      </PopupContainer>
    ),
    iconAnchor: [110, 0],
  });

  return (
    <Marker
      ref={markerRef}
      position={[lat, lng]}
      icon={customIcon}
      pane="tollPlazaPane"
      zIndexOffset={1100}
    />
  );
}

export default MarkerTollsPlazaInfo;
